import { TranslateField } from "../../types/translate-field";

export interface GetInfoResponse {
    item_id: string;
    item_desc_eng: string;
    item_desc_cnt: string;
    item_desc_cns: string;
}

export const ToTranslateField = (res: GetInfoResponse): TranslateField => {
    return {
        key: res.item_id,
        values: [
            { locale: 'en', value: res.item_desc_eng.replace(/(?:\r\n|\r|\n)/g, '<br>') },
            { locale: 'zh', value: res.item_desc_cnt.replace(/(?:\r\n|\r|\n)/g, '<br>') },
            { locale: 'cn', value: res.item_desc_cns.replace(/(?:\r\n|\r|\n)/g, '<br>') },
        ]
    }
}